import React from 'react';
import { Phone, Mail, Clock, Trash2, Snowflake, ArrowUp } from 'lucide-react';
import { companyInfo, services } from '../data/mock';

const Footer = ({ onGetEstimate }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const quickLinks = [
    { name: 'Services', href: '#services' },
    { name: 'How It Works', href: '#process' },
    { name: 'Service Areas', href: '#areas' },
    { name: 'About Us', href: '#about' },
  ];

  const junkServices = services.filter(s => s.category === 'junk').map(s => s.title);
  const snowServices = services.filter(s => s.category === 'snow').map(s => s.title);

  return (
    <footer className="bg-[#0A0A0A] text-white border-t border-[#2A2A2A]">
      {/* CTA Banner */}
      
      {/* Main Footer */}
      <div className="container mx-auto px-4 px-4 pt-24 pb-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_snowpro-service/artifacts/tn5k0xbg_image.png" 
                alt="K&A Multi-Services" 
                className="h-14 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Your trusted partner for junk removal and snow clearing services in Edmonton and surrounding areas. Committed to excellence.
            </p>
            <div className="space-y-3 mb-6">
              <a href={`https://wa.me/50373157851?text=${encodeURIComponent("Hello, I visited K&A Junk and Snow solutions website and I have a question.")}`} className="flex items-center gap-3 text-gray-400 hover:text-[#7BA428] transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                WhatsApp
              </a>
              <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-3 text-gray-400 hover:text-[#7BA428] transition-colors">
                <Mail className="w-5 h-5" />
                {companyInfo.email}
              </a>
              <div className="flex items-start gap-3 text-gray-400">
                <Clock className="w-5 h-5 flex-shrink-0 mt-0.5" />
                {companyInfo.hours}
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-[#7BA428] transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
              <li>
                <button
                  onClick={onGetEstimate}
                  className="text-[#7BA428] hover:text-white transition-colors font-semibold"
                >
                  Get Free Estimate
                </button>
              </li>
            </ul>
          </div>

          {/* Junk Removal Services */}
          <div>
            <h4 className="font-bold text-lg mb-6 flex items-center gap-2">
              <Trash2 className="w-5 h-5 text-[#7BA428]" />
              Junk Removal
            </h4>
            <ul className="space-y-3">
              {junkServices.map((service) => (
                <li key={service}>
                  <span className="text-gray-400">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Snow Removal Services */}
          <div>
            <h4 className="font-bold text-lg mb-6 flex items-center gap-2">
              <Snowflake className="w-5 h-5" />
              Snow Removal
            </h4>
            <ul className="space-y-3">
              {snowServices.map((service) => (
                <li key={service}>
                  <span className="text-gray-400">{service}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#2A2A2A]">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {new Date().getFullYear()} K&A Multi-Services. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors">
                Terms of Service
              </a>
              <button
                onClick={scrollToTop}
                className="w-10 h-10 bg-[#1A1A1A] border border-[#2A2A2A] rounded-full flex items-center justify-center hover:bg-[#7BA428] hover:text-black hover:border-[#7BA428] transition-all"
                aria-label="Scroll to top"
              >
                <ArrowUp className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
